import { CurrencyPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'customCurrency'})
export class CustomCurrencyPipe implements PipeTransform {

  constructor(private cp: CurrencyPipe) { }

  currencyISOCodes: string[] = ['AUD', 'SGD', 'HKD', 'MXN', 'BRL', 'CAD'];

  transform(value: number, currencyISOCode?: string): string {
    let result: string;

    if (this.currencyISOCodes.includes(currencyISOCode)) {
      result = this.cp.transform(value, currencyISOCode + ' ', 'code');
    } else {
      result = this.cp.transform(value, currencyISOCode);
    }

    return result;
  }
}
